/* eslint-disable @repo/internal/react/require-jsdoc */

import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Text, xcss } from '@atlaskit/primitives';

export const Paragraph = ({
	size,
	children,
}: {
	size: 'medium' | 'large';
	children: ReactNode;
}) => (
	<Box xcss={paragraphStyles}>
		<Text size={size || 'large'} as="p">
			{children}
		</Text>
	</Box>
);

const paragraphStyles = xcss({
	marginBlockEnd: 'space.100',
});
